import { Field } from 'formik';
import styled from 'styled-components/macro';

export const Label = styled.label<{ label?: string; error?: string }>`
  display: inline-block;

  height: ${({ label }) => (!!label ? 'auto' : '16px')};

  margin-bottom: ${({ theme }) => theme.spacing.zero_2};

  color: ${({ theme, error }) =>
    error === 'hasError' ? theme.colors.negative_dark : theme.colors.black};

  font-size: ${({ theme }) => theme.fontSize.xxs};
  line-height: ${({ theme }) => theme.lineHeight.one};

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    height: ${({ label }) => (!!label ? 'auto' : '0')};
    margin-bottom: ${({ label, theme }) => (!!label ? theme.spacing.zero_1 : theme.spacing.zero)};
  }
`;

export const Input = styled(Field)`
  display: block;

  width: 100%;
  height: 2.5rem;

  border: 1px solid;
  border-color: ${({ theme, error }) =>
    error === 'hasError' ? theme.colors.negative_dark : theme.colors.black_10};
  border-radius: ${({ theme }) => theme.spacing.zero_1};

  color: ${({ value, theme, disabled }) => {
    if (!!value) {
      return theme.colors.black_100;
    } else if (disabled) {
      return theme.colors.black_40;
    } else return theme.colors.black_60;
  }};

  background-color: ${({ theme }) => theme.colors.white};
  ::-webkit-datetime-edit {
    padding-left: 4px;
  }
  ::-webkit-calendar-picker-indicator {
    opacity: ${({ value }) => (!!value ? '1' : '0.2')};
  }

  :focus {
    border: 1px solid;
    border-color: ${({ theme }) => theme.colors.black};
  }

  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'default')};
`;
